import { render, staticRenderFns } from "./mnewsListDetail.vue?vue&type=template&id=3a86d93d&scoped=true&"
import script from "./mnewsListDetail.vue?vue&type=script&lang=js&"
export * from "./mnewsListDetail.vue?vue&type=script&lang=js&"
import style0 from "./mnewsListDetail.vue?vue&type=style&index=0&id=3a86d93d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a86d93d",
  null
  
)

export default component.exports